var _react_refresh_temp_1;
import { jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
const ParticipantName = ({ name, isCurrentUser }) => {
    return (_jsxs("p", { className: "text-[11px] xl:text-[13px] primaryColor dark:text-darkText", children: [name, " ", isCurrentUser ? ' (me)' : null] }));
};
_react_refresh_temp_1 = ParticipantName;
$RefreshReg$(_react_refresh_temp_1, "ParticipantName");
export default ParticipantName;
